import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Checkbox,
  Container,
  FormControl,
  Input,
  Stack,
  Text,
  useDisclosure,
  Link,
  Flex,
  IconButton,
  FormErrorMessage,
} from "@chakra-ui/react";
import { RepeatIcon } from "@chakra-ui/icons";
import PrimaryButton from "../../components/PrimaryButton";
import BrandedHeading from "../../components/BrandedHeading";
import OtpModal from "./components/OtpModal";
import {
  fetchHospitalsRequest,
  registerRequest,
  verifyOTPRequest,
} from "./authStore/actions";
import { useDispatch, useSelector } from "react-redux";
import { PasswordField } from "./components/PasswordField";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ErrorAlert from "../../components/ErrorAlert";
import validator from "validator";
import AlphaInput from "../../components/AlphaInput";
import { fetchDesignationRequest } from "./authStore/actions";
import { Select } from "chakra-react-select";
import { handleSelectChange } from "../common/form/utils";
import Alert from "../../components/Alert";
import LoadingSpinner from "../../components/LoadingSpinner";
import "../../layout/base.css";

export const Register = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    is_reg,
    token,
    error,
    regOtpResponse,
    designationData,
    hospitalsData,
    loading,
  } = useSelector((state) => state.auth);
  const [passwordMismatchError, setPasswordMismatchError] = useState(false);
  const [passwordValidation, setPasswordValidation] = useState(false);
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [userInput, setUserInput] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [phoneValid, setPhoneValid] = useState(true);
  const [countryCode, setCountryCode] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    confirm_password: "",
    designation: "",
    hospital: [],
  });

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        onSubmit();
      }
    };
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [formData]);

  const phoneLengths = {
    BD: { min: 10, max: 10 },
    KE: { min: 10, max: 10 },
    SO: { min: 7, max: 8 },
    IQ: { min: 10, max: 10 },
    ET: { min: 9, max: 9 },
    MU: { min: 8, max: 8 },
    NG: { min: 8, max: 8 },
    OM: { min: 7, max: 8 },
    TZ: { min: 6, max: 6 },
    MM: { min: 8, max: 10 },
    YE: { min: 9, max: 9 },
    UZ: { min: 9, max: 9 },
    NP: { min: 10, max: 10 },
    MZ: { min: 12, max: 12 },
    TM: { min: 8, max: 8 },
    IN: { min: 10, max: 10 },
    TH: { min: 9, max: 9 },
    TR: { min: 10, max: 10 },
  };

  useEffect(() => {
    refreshCaptcha();
    let payload = { role: "IPS", source: "Web" };
    dispatch(fetchDesignationRequest(payload));
    let hsp_payload = { country: "India", user_type: "IPS", source: "Web" };
    dispatch(fetchHospitalsRequest(hsp_payload));
  }, []);

  useEffect(() => {
    if (is_reg) {
      onOpen();
    }
  }, [is_reg]);

  useEffect(() => {
    if (regOtpResponse) {
      onClose();
      setIsAlertOpen(true);
    } else {
      setIsAlertOpen(false);
    }
  }, [regOtpResponse]);

  // const identifyRole = (email) => {
  //   const domain = email.split("@")[1];
  //   if (domain === "apollohospital.com") {
  //     return "IPS";
  //   } else {
  //     return "HCF";
  //   }
  // };

  const validatePhoneNumber = (
    value,
    country,
    dialCode,
    name,
    setFormErrors
  ) => {
    const countryCode = country?.toUpperCase();
    if (countryCode && phoneLengths[countryCode]) {
      const { min, max } = phoneLengths[countryCode];
      const length = value.replace(/\D/g, "").length;
      const min_length =
        min + (dialCode ? dialCode.replace(/\D/g, "").length : 0);
      const max_length =
        max + (dialCode ? dialCode.replace(/\D/g, "").length : 0);

      if (length > max_length) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          phone: `Phone number length for ${name} should be maximum ${max} digits.`,
        }));
        return false;
      } else if (length < min_length) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          phone: `Phone number length for ${name} should be minimum ${min} digits.`,
        }));
        return false;
      } else {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          phone: "",
        }));
        return true;
      }
    }
    return true;
  };

  const validateForm = (values) => {
    const errors = {};
    if (!values.name) {
      errors.name = "This field is required";
    } else if (values.name.length < 3) {
      errors.name = "Name must be at least 3 characters";
    }
    if (!values.email) {
      errors.email = "This field is required";
    } else if (!validator.isEmail(values.email)) {
      errors.email = "Please enter valid Email address";
    }
    if (
      (formErrors.phone === undefined && values.phone === "") ||
      formData.phone === countryCode
    ) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        phone: "This field is required",
      }));
      errors.phone = "This field is required";
    } else {
      if (formErrors.phone && formErrors.phone !== "") {
        errors.phone = formErrors.phone;
      }
    }
    if (!values.password) {
      errors.password = "This field is required";
    } else if (!validatePassword(values.password)) {
      errors.password =
        "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one special character.";
    }
    if (!values.confirm_password) {
      errors.confirm_password = "This field is required";
    } else if (values.password !== values.confirm_password) {
      errors.confirm_password = "Password do not match";
    }
    if (!values.hospital || values.hospital.length === 0) {
      errors.hospital = "This field is required";
    }
    if (!values.designation) {
      errors.designation = "This field is required";
    }
    if (!values.checkbox) {
      errors.checkbox =
        "Please agree to the Terms of Service and Privacy Policy";
    }
    return errors;
  };

  // const isAppoloHospitalEmail = (email) => {
  //   if (email) {
  //     return email?.endsWith("@apollohospital.com");
  //   } else {
  //     return false;
  //   }
  // };

  const handlePhoneChange = (val) => {
    setFormData({ ...formData, phone: val });
  };

  const validatePassword = (password) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+}{"':;?/>.<,])(?=.{8,})/;
    return regex.test(password);
  };

  function generateCaptcha() {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 5; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return result;
  }

  const refreshCaptcha = () => {
    setCaptcha(generateCaptcha());
    setUserInput("");
    setErrorMessage("");
  };

  const onSubmit = () => {
    const errors = validateForm(formData);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const { password, confirm_password } = formData;
      if (!validatePassword(password)) {
        setPasswordValidation(true);
        return;
      }

      if (password !== confirm_password) {
        setPasswordMismatchError(true);
        return;
      }

      if (userInput !== captcha) {
        setErrorMessage("Incorrect CAPTCHA. Please try again.");
        return;
      }
      const payload = {
        name: formData.name,
        email: formData.email,
        mobile_no: formData.phone,
        pwd: formData.password,
        repwd: formData.password,
        hospital: formData.hospital,
        designation: formData.designation?.value,
        user_type: "IPS",
        source: "Web",
      };
      dispatch(registerRequest(payload));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setFormErrors({ ...formErrors, [name]: false });
  };

  const handleOtpSubmit = (otp) => {
    let payload = {
      usr: formData.email,
      otp: otp,
      token: token,
      otp_type: "Reg",
      user_type: "IPS",
      source: "Web",
    };
    dispatch(verifyOTPRequest(payload));
  };

  return (
    <Flex minHeight="100vh" alignItems="center" justifyContent="center">
      {loading && <LoadingSpinner />}
      <Container
        maxW="lg"
        py={{ base: "12", md: "24" }}
        px={{ base: "0", sm: "8" }}
      >
        <Stack spacing="8">
          <Box
            py={{ base: "0", sm: "8" }}
            px={{ base: "4", sm: "10" }}
            bg={{ base: "transparent", sm: "bg.surface" }}
            boxShadow="5px 5px 30px 0px rgb(224 222 222 / 89%)"
            borderRadius={{ base: "none", sm: "xl" }}
          >
            <Stack spacing="6">
              <Stack spacing="5">
                <Stack spacing="1" textAlign="center">
                  <BrandedHeading fontWeight="700">Registration</BrandedHeading>
                </Stack>
                <Stack spacing="1">
                  <BrandedHeading fontWeight="600" as="h2" size="md">
                    New Here? Set up your Profile
                  </BrandedHeading>
                  <Text fontSize="xs">
                    Create an account so you can manage your services faster
                  </Text>
                </Stack>
              </Stack>
              <Stack spacing="6">
                <FormControl isInvalid={!!formErrors.name}>
                  <AlphaInput
                    placeholder="Enter Your Full Name"
                    value={formData["name"]}
                    onChange={handleChange}
                    name="name"
                    isInvalid={!!formErrors.name}
                    regex={/^[a-zA-Z ]*$/}
                    maxLength={40}
                  />
                  <FormErrorMessage>{formErrors.name}</FormErrorMessage>
                </FormControl>
                <FormControl isInvalid={!!formErrors.email}>
                  <Input
                    id="email"
                    placeholder="Enter Email"
                    value={formData["email"]}
                    onChange={handleChange}
                    name="email"
                    required
                  />
                  <FormErrorMessage>{formErrors.email}</FormErrorMessage>
                </FormControl>
                <FormControl isInvalid={!!formErrors.phone || !phoneValid}>
                  <PhoneInput
                    id="mobileNumber"
                    name="mobileNumber"
                    defaultCountry="IN"
                    preferredCountries={["in", "th", "tr"]}
                    country={formData.country || "in"}
                    value={formData.phone}
                    onChange={(value, country) => {
                      setFormErrors({
                        ...formErrors,
                        phone: "",
                      });
                      setCountryCode(country.dialCode);
                      setFormData({
                        ...formData,

                        phone: value,
                      });
                      const isValid = validatePhoneNumber(
                        value,
                        country.countryCode,
                        country.dialCode,
                        country.name,
                        setFormErrors,
                        formErrors
                      );
                      setPhoneValid(isValid);
                      handlePhoneChange(value, country);
                    }}
                    inputStyle={{
                      width: "100%",
                      height: "40px",
                      border: formErrors.phone
                        ? "2px solid red !important"
                        : "",
                    }}
                    inputProps={{
                      name: "phone",
                      required: true,
                    }}
                    enableSearch="true"
                    international
                    isInvalid={!!formErrors.phone}
                    placeholder="Enter Phone Number"
                    countryCodeEditable={false}
                  />

                  <FormErrorMessage>{formErrors.phone}</FormErrorMessage>
                </FormControl>

                <FormControl
                  isInvalid={passwordValidation || !!formErrors.password}
                >
                  <PasswordField
                    id="password"
                    placeholder="Enter Password"
                    value={formData["password"]}
                    onChange={handleChange}
                    isInvalid={passwordValidation || !!formErrors.password}
                    name="password"
                    required
                  />
                  <FormErrorMessage>{formErrors.password}</FormErrorMessage>
                </FormControl>
                <FormControl
                  isInvalid={
                    passwordMismatchError || !!formErrors.confirm_password
                  }
                >
                  <PasswordField
                    id="confirm_password"
                    placeholder="Confirm Password"
                    value={formData["confirm_password"]}
                    onChange={handleChange}
                    isInvalid={
                      passwordMismatchError || !!formErrors.confirm_password
                    }
                    name="confirm_password"
                    required
                  />
                  <FormErrorMessage>
                    {formErrors.confirm_password}
                  </FormErrorMessage>
                </FormControl>
                <FormControl isInvalid={!!formErrors.hospital}>
                  <Select
                    name="hospital"
                    id="hospital"
                    placeholder="Select Hospital"
                    options={hospitalsData?.data}
                    value={formData.hospital?.label}
                    isMulti={true}
                    onChange={(selectedOption) => {
                      const selectedHospitalNames = selectedOption.map(
                        (option) => option.value
                      );
                      setFormData((prevState) => ({
                        ...prevState,
                        hospital: selectedHospitalNames,
                      }));
                    }}
                  />
                  <FormErrorMessage>{formErrors.hospital}</FormErrorMessage>
                </FormControl>

                <FormControl isInvalid={!!formErrors.designation}>
                  <Select
                    name="designation"
                    id="designation"
                    placeholder="Select Designation"
                    options={designationData?.data}
                    value={formData.designation}
                    onChange={(selectedOption, actionMeta) =>
                      handleSelectChange(
                        formData,
                        setFormData,
                        formErrors,
                        setFormErrors,
                        selectedOption,
                        actionMeta
                      )
                    }
                  />
                  <FormErrorMessage>{formErrors.designation}</FormErrorMessage>
                </FormControl>
              </Stack>
              <Flex alignItems={"center"}>
                <Text
                  fontSize="xl"
                  fontWeight="bold"
                  letterSpacing="wider"
                  backgroundColor={"blue.600"}
                  color={"white"}
                  userSelect="none"
                  onCopy={(e) => e.preventDefault()}
                >
                  {captcha}
                </Text>
                <IconButton
                  icon={<RepeatIcon />}
                  aria-label="Refresh captcha"
                  onClick={refreshCaptcha}
                  ml="1"
                  mr="3"
                />
                <Input
                  type="text"
                  value={userInput}
                  onChange={(e) => setUserInput(e.target.value)}
                  placeholder="Enter Captcha"
                  borderColor={errorMessage ? "red.500" : undefined}
                />
              </Flex>
              <Flex alignItems="flex-start" mt="-10px">
                {errorMessage && (
                  <Text color="red.500" fontSize="sm">
                    {errorMessage}
                  </Text>
                )}
              </Flex>
              <Flex alignItems="flex-start">
                <Checkbox
                  style={{ paddingTop: "4px" }}
                  isChecked={formData.checkbox}
                  onChange={(e) =>
                    setFormData({ ...formData, checkbox: e.target.checked })
                  }
                />
                <Text ml={3} flex="1">
                  By signing up, you agree to the Terms of Services and Privacy
                  Policy
                </Text>
              </Flex>
              <Flex alignItems="flex-start" mt="-20px">
                {formErrors.checkbox && (
                  <Text color="red.500" fontSize="sm">
                    {formErrors.checkbox}
                  </Text>
                )}
              </Flex>
              <Stack spacing="6">
                {error && error.message && (
                  <ErrorAlert message={error.message} />
                )}
                <PrimaryButton
                  onClick={onSubmit}
                  // isLoading={loading}
                  loadingText="Registering"
                  spinnerPlacement="end"
                >
                  Sign Up
                </PrimaryButton>
                <Stack spacing={{ base: "2", md: "3" }} textAlign="center">
                  <Text color="fg.muted">
                    Already have an account?{" "}
                    <Link href="/" style={{ color: "#57ACFF" }}>
                      Login Here
                    </Link>
                  </Text>
                </Stack>
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Container>
      <OtpModal
        isOpen={isOpen}
        onClose={onClose}
        onSubmit={handleOtpSubmit}
        user={formData.email}
        otpType="Reg"
      />
      <Alert
        isOpen={isAlertOpen}
        title="Success!"
        type="success"
        onClose={() => {
          navigate("/");
          setIsAlertOpen(false);
        }}
        body={regOtpResponse?.message}
      />
    </Flex>
  );
};
